/** True where the platform has a share sheet; the card labels its button differently then. */
export const canUseNativeShare = (): boolean => typeof navigator.share === 'function';

/**
 * Hands the link to the platform's share sheet where there is one, and writes it to the clipboard
 * otherwise. Rejects when the sheet was dismissed or nothing worked, so the caller neither records
 * a share nor shows feedback for a cancelled one.
 */
export async function shareEventUrl(url: string, title: string): Promise<'native' | 'copy'> {
  if (canUseNativeShare()) {
    await navigator.share({ title, url });
    return 'native';
  }
  await navigator.clipboard.writeText(url);
  return 'copy';
}
